export default __webpack_public_path__ + "static/media/car.41f2610d.jpeg";